// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"CardsSwiper_swiperContainer__F1TlD","card":"CardsSwiper_card__2bqZZ","active":"CardsSwiper_active__JwLHh"};